<script setup lang="ts">
import type { CmsElementHeadlineText } from "~/composables/useCustom";
import { useCmsElementConfig } from "#imports";

const props = defineProps<{
  content: CmsElementHeadlineText;
}>();

const { getConfigValue } = useCmsElementConfig(props.content);

const boxes = computed(() => getConfigValue("boxes"));
</script>

<template>
<section class="pb-10 md:pb-14 lg:pb-20">
  <div class="container">
    <div class="bg-cust_cream text-center pt-10 md:pt-11 pb-7 md:pb-12 lg:pb-16 rounded-3xl px-3 flex flex-wrap justify-center gap-y-6">
      <div v-for="box in boxes" :key="box.id" class="sm:px-5 w-full sm:w-1/2 lg:w-1/3 xl:w-1/4">
        <div class="g_icon h-12 md:h-16 text-[0] mb-4 md:mb-8 flex items-center justify-center">
            <img
                v-if="box.icons"
                :src="box.icons.url"
                :alt="box.icons.fileName"
                loading="lazy"
                class="max-h-[90%]"
              />
        </div>
          <h5 class="mb-4 md:mb-6 lg:mb-8 text-xl lg:text-2xl font-extrabold font-redit_sans_con leading-[1.1]">{{ box.headline }}</h5>
          <p class="text-base md:text-lg tracking-[0.36px] mb-0">{{ box.fliesstext }}</p>
      </div>
    </div>
    </div>
  </section>
</template>
